import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';

Vue.use(Vuex);

//暴露strore对象
export default new Vuex.Store({
  state: {
    evaluationTaskData:'',
  },
  mutations: {},
  getters,
  actions,
});



// WEBPACK FOOTER //
// ./src/store/index.js